import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageview } from '../functions/analytics';

// The inline gtag snippet in public/index.html already sends a page_view
// for the initial load, so the first location here is skipped to avoid
// double-counting it.
const RouteTracker = () => {
  const location = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    trackPageview(location.pathname + location.search);
  }, [location]);

  return null;
};

export default RouteTracker;
